module.exports = __webpack_public_path__ + "img/spx.78abea7c.png";